// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// Forms
import { Field, formValueSelector, reduxForm } from "redux-form";
// moment
import moment from "moment";
// i18n
import { withNamespaces } from "react-i18next";
// Ducks
import {
  clearDates,
  clearMissingExamsParts,
  fetchDates,
  fetchLicences,
  fetchParts,
  resetExaminationData,
  setSelectedDate
} from "./Exams.ducks";
import { navigateTo } from "../Dashboard.ducks";
// Validators
import { date, required } from "../../../services/validators";
// Components
import { DateInput } from "../../../components/Input";
import BlockLoader from "./components/BlockLoader";
import Form from "../../../components/Form";
import MultiSelect from "../../../components/MultiSelect";
import Select from "../../../components/Select";
import BookingsToolbar from "../components/BookingsToolbar";

class Exams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasSearchCompleted: false,
      qualificationConfirmationChecked: false
    };
  }

  componentDidMount() {
    const { change, fetchLicences, fetchParts, formState, resetExaminationData } = this.props;

    resetExaminationData();
    fetchLicences();

    if (formState.parts && formState.parts.length > 0) {
      change("parts", []);
      /**
       * missingExamParts.licenceId is the ID of the licence
       * Fetch the parts for the missing exam
       */
      fetchParts(formState.licence);
    }
  }

  handleLicenceChange = (event) => {
    const { change, clearMissingExamsParts, fetchParts } = this.props;

    clearMissingExamsParts();
    fetchParts(event.target.value);
    change("parts", []);
    change("startDate", moment().format(`L`));
  };

  handleQualificationConfirmationChange = () => {
    if (this.state.qualificationConfirmationChecked === false) {
      this.setState({ hasSearchCompleted: false });
    }
  };

  handleLoadMoreRows = ({ offset, pageSize }) => {
    const { fetchDates, formState } = this.props;

    fetchDates({
      licenceId: formState.licence,
      offset,
      pageSize,
      partsId: formState.parts.map((part) => part.id),
      startDate: formState.startDate
    });
  };

  resetDates = () => {
    const { clearDates } = this.props;

    clearDates();
  };

  handlePartsOptions = () => {
    const {
      exams: { parts }
    } = this.props;

    return parts.map((part) => ({ ...part, label: part.value }));
  };

  onSubmit = (values) => {
    const { fetchDates } = this.props;

    this.setState(
      {
        hasSearchCompleted: true
      },
      () => {
        fetchDates({
          // eslint-disable-next-line react/destructuring-assignment
          licenceId: values.licence,
          // eslint-disable-next-line react/destructuring-assignment
          partsId: values.parts ? values.parts.map((part) => part.key) : [],
          // eslint-disable-next-line react/destructuring-assignment
          startDate: values.startDate
        });
      }
    );
  };

  transformDatesBeforeTable = () => {
    const {
      exams: { dates }
    } = this.props;

    return dates.map((date) => {
      const dateCopy = JSON.parse(JSON.stringify(date));
      dateCopy.date = moment(new Date(date.date)).format(`L`);
      return dateCopy;
    });
  };

  render() {
    const {
      exams: { count, licences, missingExamParts, filtered, requiresQualificationConfirmation },
      handleSubmit,
      valid,
      t
    } = this.props;

    const { hasSearchCompleted, qualificationConfirmationChecked } = this.state;
    const defaultValueKey = missingExamParts && missingExamParts.licenceId;
    const parts = this.handlePartsOptions();

    return (
      <div className="container">
        <BookingsToolbar />
        <Form
          bootStrapClass="col-sm-12 well no-padding"
          buttonDisabled={!valid}
          buttonLeft
          buttonText={t(`modules.localization.register.authenticated.exams.search`)}
          handleSubmit={handleSubmit}
          onSubmit={this.onSubmit}
          title={t(`modules.localization.register.authenticated.exams.bookExamination`)}
        >
          <fieldset>
            <section className="col col-xs-12 col-sm-12 col-md-10 col-lg-7">
              <Field
                component={Select}
                defaultValueLabel={t(
                  `modules.localization.register.authenticated.exams.pickLicence`
                )}
                defaultValueKey={defaultValueKey}
                errorMessage=" "
                label={t(`modules.localization.register.authenticated.exams.licence`)}
                name="licence"
                onChange={this.handleLicenceChange}
                options={licences}
                validate={required}
              />
            </section>
            {Boolean(parts.length) && (
              <section className="col col-xs-12 col-sm-12 col-md-10 col-lg-7">
                <Field
                  component={MultiSelect}
                  errorMessage=" "
                  label={t(`modules.localization.register.authenticated.exams.parts`)}
                  allowSelectAll={Boolean(true)}
                  name="parts"
                  onChange={this.resetDates}
                  options={parts}
                  placeholder={t(`modules.localization.register.authenticated.exams.pickPart`)}
                  validate={required}
                />
              </section>
            )}
          </fieldset>
          <fieldset>
            <section className="col col-xs-6 col-sm-6 col-md-4 col-lg-3">
              <Field
                component={DateInput}
                disableDays={{ before: new Date() }}
                iconClass="icon-append fa fa-calendar"
                label={t(`modules.localization.register.authenticated.exams.startDate`)}
                name="startDate"
                onChange={this.resetDates}
                validate={date}
              />
            </section>
          </fieldset>
          {requiresQualificationConfirmation && (
            <fieldset>
              <section className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <label className="checkbox">
                  <input
                    name="candidateQualificationConfirmation"
                    type="checkbox"
                    defaultChecked={Boolean(false)}
                    value={qualificationConfirmationChecked}
                    onChange={this.handleQualificationConfirmationChange}
                    required={Boolean(requiresQualificationConfirmation)}
                  />
                  <i />
                  <span>
                    {t(
                      "modules.localization.register.authenticated.exams.qualificationConfirmation"
                    )}
                  </span>
                </label>
              </section>
            </fieldset>
          )}
        </Form>
        {hasSearchCompleted && (
          <BlockLoader
            loadMoreRows={this.handleLoadMoreRows}
            rows={this.transformDatesBeforeTable()}
            filter={filtered}
            totalResults={count}
          />
        )}
      </div>
    );
  }
}

Exams.propTypes = {
  clearDates: PropTypes.func.isRequired,
  clearMissingExamsParts: PropTypes.func.isRequired,
  exams: PropTypes.object,
  fetchDates: PropTypes.func.isRequired,
  fetchLicences: PropTypes.func.isRequired,
  fetchParts: PropTypes.func.isRequired,
  formState: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  resetExaminationData: PropTypes.func.isRequired,
  t: PropTypes.func,
  valid: PropTypes.bool
};

const mapStateToProps = (state) => {
  const { exams } = state;
  const formState = formValueSelector("examSearch")(state, "licence", "parts", "startDate");

  return {
    exams,
    formState,
    isUserActive: state.auth.profile.isUserActive,
    initialValues: {
      startDate: formState.startDate || moment().format(`L`),
      licence:
        (exams.missingExamParts && exams.missingExamParts.licenceId) || formState.licence || null,
      parts:
        exams.missingExamParts &&
        exams.missingExamParts.examPartsId &&
        exams.missingExamParts.examPartsId.length === exams.parts.length
          ? exams.parts
              .filter((part) => exams.missingExamParts.examPartsId.includes(part.key))
              .map((p) => ({
                key: p.key,
                value: p.value,
                label: p.value
              }))
          : formState.parts || []
    }
  };
};

const mapsDispatchToProps = {
  clearDates,
  clearMissingExamsParts,
  fetchDates,
  fetchLicences,
  fetchParts,
  navigateTo,
  resetExaminationData,
  setSelectedDate
};

export default compose(
  connect(
    mapStateToProps,
    mapsDispatchToProps
  ),
  reduxForm({
    form: `examSearch`,
    enableReinitialize: true,
    destroyOnUnmount: false
  }),
  withNamespaces()
)(Exams);
